// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210504/js/" + chunkId + "." + {"44":"02fe238b","225":"9e0b296d","481":"05c29a96","486":"fc797361","770":"cdcfd020"}[chunkId] + ".0.376408955409677.chunk.js";
};